<template>
  <b-modal
    ref="confirmPackageModal"
    title="Chốt gói sử dụng"
    size="md"
    @hidden="resetForm"
    hide-footer
  >
    <div class="confirm-package-content">
      <div class="package-info mb-3">
        <div v-if="packageName" class="mb-2"><strong>Gói hiện tại:</strong> {{ packageName }}</div>
        <div v-if="packagePrice" class="mb-2">
          <strong>Giá:</strong> {{ packagePrice | formatCurrency }}
        </div>
      </div>

      <div class="form-group">
        <label for="note" class="form-label-required"
          >Nhập lý do <span class="text-danger">*</span></label
        >
        <textarea
          id="note"
          v-model="note"
          class="form-control"
          rows="4"
          placeholder="Nhập lý do"
          required
        ></textarea>
      </div>

      <div class="alert alert-info mt-3">
        <div class="note-text">
          <strong>Lưu ý:</strong> Sau khi chốt gói sử dụng, yêu cầu sẽ được đánh dấu là "Đã xác
          nhận" và không thể khôi phục. Vui lòng kiểm tra kỹ trước khi xác nhận. Liên hệ bộ phận hỗ
          trợ nếu cần.
        </div>
      </div>

      <div class="d-flex justify-content-end mt-4">
        <button type="button" class="btn btn-secondary mr-2" @click="hide">Hủy</button>
        <button type="button" class="btn btn-primary" @click="confirm" :disabled="loading">
          <span v-if="loading">
            <span class="spinner-border spinner-border-sm mr-1" role="status"></span>
            Đang xử lý...
          </span>
          <span v-else>Xác nhận</span>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
  import { ComboService } from '@/services/combo.service'
  import { showMess } from '@/config/utils'

  export default {
    name: 'ConfirmPackagePopup',
    props: {
      id: {
        type: [String, Number],
        default: null,
      },
    },
    data() {
      return {
        note: '',
        loading: false,
        packageName: '',
        packagePrice: null,
      }
    },
    methods: {
      show(packageInfo = {}) {
        this.packageName = packageInfo.name || ''
        this.packagePrice = packageInfo.price || null
        this.$refs.confirmPackageModal.show()
      },
      hide() {
        this.$refs.confirmPackageModal.hide()
      },
      resetForm() {
        this.note = ''
        this.packageName = ''
        this.packagePrice = null
      },
      async confirm() {
        if (!this.id) {
          showMess(
            this,
            'Lỗi',
            'Không tìm thấy thông tin yêu cầu',
            'danger',
            'b-toaster-top-right',
            3000
          )
          return
        }

        if (!this.note || !this.note.trim()) {
          showMess(this, 'Lỗi', 'Vui lòng nhập lý do', 'danger', 'b-toaster-top-right', 3000)
          return
        }

        try {
          this.loading = true
          const response = await ComboService.confirmPackage({
            id: this.id,
            note: this.note.trim(),
          })

          if (response.code === 1000) {
            showMess(
              this,
              'Thành công',
              'Chốt gói sử dụng thành công',
              'success',
              'b-toaster-top-right',
              3000
            )
            this.hide()
            this.$emit('confirmed')
          } else {
            showMess(
              this,
              'Lỗi',
              response.message || 'Chốt gói sử dụng thất bại',
              'danger',
              'b-toaster-top-right',
              3000
            )
          }
        } catch (error) {
          console.error('Error confirming package:', error)
          showMess(
            this,
            'Lỗi',
            'Có lỗi xảy ra khi chốt gói sử dụng',
            'danger',
            'b-toaster-top-right',
            5000
          )
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>

<style scoped>
  .confirm-package-content {
    padding: 10px 0;
  }

  .package-info {
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border-left: 4px solid #007bff;
    font-size: 15px;
  }

  textarea.form-control {
    resize: vertical;
    min-height: 100px;
  }

  .alert-info {
    background-color: #e7f3ff;
    border-color: #b3d9ff;
    color: #004085;
  }

  .note-text {
    font-size: 14px;
    line-height: 1.5;
  }

  .form-label-required {
    font-size: 15px;
    font-weight: 500;
  }
</style>
